// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"sj-z","carouselContainer":"tj-z","carouselContent":"uj-z"};